
<template>
    <div ref="listWrap">
        <wrapper-list
                @add="paasAddPage"
                @calculate="paasCalculate"
                ref="wrapperList" >
            <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
            </Form>
            <Table slot="table" stripe border :height="tableHeight"
                   :data="tableData"
                   :columns="tableColumns"
                   @on-selection-change="selectTableDataChange"
                   @on-sort-change="sortTableData"
                   :no-data-text="noDataText">
            </Table>
            <Page slot="page"  :total="totalRecords"
                  show-total show-sizer
                  @on-change="changePage"
                  @on-page-size-change="changePageSize">
            </Page>
        </wrapper-list>
    </div>
</template>
<script>
    import wrapperList from "@components/paas/wrapper-list";
    import metaList from "@assets/js/list/meta-list.js";
    import EnumShow from "@components/paas/enum-show";  //如果有枚举，需要引入
    import CellBar from '@components/paas/cell-bar'; //列表内操作
    import {saveOnshelf} from "@api/card.js";
    export default {
        name: "list",
        mixins: [ metaList ],
        components: { wrapperList,EnumShow  ,CellBar},
        data() {
            return {
                serviceUrl:"/eb/card/types",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                queryParam:{
                },
                defaultLabelWidth:200,
                tableColumns:[
                    {
                        title: '卡的名称',
                        key: 'cardName',
                    },
                    {
                        title: '卡种类',
                        key: 'cardCategory',
                        render:(h,params)=>{
                            return h(EnumShow,{
                                props:{
                                    enumGroupCode:'crmdict',
                                    enumCode:'cardCategory',
                                    value:params.row.cardCategory
                                }
                            })
                        }
                    },
                    {
                        title: '卡类型',
                        key: 'cardType',
                        render:(h,params)=>{
                            return h(EnumShow,{
                                props:{
                                    enumGroupCode:'crmdict',
                                    enumCode:'cardType',
                                    value:params.row.cardType
                                }
                            })
                        }
                    },
                    {
                        title: '面值',
                        key: 'faceValue',
                    },
                    {
                        title: '是否定制',
                        key: 'isCustomMade',
                        render:(h,params)=>{
                            return h(EnumShow,{
                                props:{
                                    enumGroupCode:'crmdict',
                                    enumCode:'isCustomMade',
                                    value:params.row.isCustomMade
                                }
                            })
                        }
                    },
                    {
                        title: '是否上架',
                        key: 'isShelf',
                        width:100,
                        render:(h,params)=>{
                            return h('i-switch', {
                                class:"sale-status",
                                props:{
                                    type: 'primary',
                                    size:'large',
                                    value: params.row.isShelf,  //控制开关的打开或关闭状态，官网文档属性是value
                                    'true-value': "yes",
                                    'false-value':"no",
                                },
                                on: {
                                    'on-change': (value) => {
                                        params.row.isShelf = value;
                                        //实时保存数据
                                        this.saveOnShelfData(params.row);
                                    }
                                }
                            },[
                                h('span', {
                                    slot: 'open',
                                    domProps: {
                                        innerHTML: '上架'
                                    }
                                }),
                                h('span', {
                                    slot: 'close',
                                    domProps: {
                                        innerHTML: '下架'
                                    }
                                }),
                            ])
                        }
                    },
                    {
                        title: '创建时间',
                        key: 'createTime',
                    },
                    {
                        title: '有效状态',
                        key: 'isDelete',
                        render:(h,params)=>{
                            return h(EnumShow,{
                                props:{
                                    enumGroupCode:'crmdict',
                                    enumCode:'isDelete',
                                    value:params.row.isDelete
                                }
                            })
                        }
                    },
                    {
                        title: '操作',
                        render: (h, params) => {
                            return h(CellBar,
                                {
                                    props:{
                                        show:'textIcon'  //操作也显示标准按钮的样式（text、icon、textIcon）
                                    },
                                    //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
                                    on: {
                                        // 子组件$emit传递函数,必须是箭头函数写法
                                        'delete':()=>{
                                            this.$nextTick(()=>{
                                                this.paasDeleteOper(params.row[this.currentIdFiledName]);
                                            })
                                        },
                                        'edit': ()=> {
                                            this.$nextTick(()=>{
                                                this.paasEditOper(params.row[this.currentIdFiledName]);
                                            })
                                        },
                                    }
                                }
                            )
                        }
                    }
                ],
            }
        },
        mounted(){
        },
        methods:{
            /**
             * 是否上架保存
             * @param row
             */
            saveOnShelfData(row){
                let param = {
                    id:row.id,
                    isShelf:row.isShelf
                }
                saveOnshelf(param).then(res=>{
                    if(res.code==200){
                        this.$Message.info("更改上架状态成功")
                    }
                })
            }
        }
    }
</script>
